"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDefaultLegend = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var recharts_1 = require("recharts");
function GetDefaultLegend() {
    return (react_1.default.createElement(recharts_1.Legend, { content: function (props) {
            var _a;
            return (react_1.default.createElement("ul", { className: "chart__legend-default" }, (_a = props === null || props === void 0 ? void 0 : props.payload) === null || _a === void 0 ? void 0 : _a.map(function (_a, index) {
                var value = _a.value, color = _a.color;
                return (react_1.default.createElement("div", { key: index, className: "chart__legend-default__item" },
                    react_1.default.createElement("div", { className: "chart__legend-default__indicator", style: { background: color } }),
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, value)));
            })));
        } }));
}
exports.GetDefaultLegend = GetDefaultLegend;
